import { useAtomValue } from "jotai";
import { useEffect, useState } from "react";

import { notEmpty } from "shared/lib/utils";

import { searchResultStreamAtom } from "scmp-app/components/search/atoms";
import { useSearchContext } from "scmp-app/components/search/contexts";
import { sendGA4Tracking } from "scmp-app/components/tracking/google-analytics-4/apis";
import type { SearchEvent } from "scmp-app/components/tracking/google-analytics-4/types";

export const useSearchResultSysTracking = () => {
  const [sentSearchId, setSentSearchId] = useState<string>();
  const [sentSearchText, setSentSearchText] = useState<string>();

  const {
    currentValue: searchText,
    embedMode,
    embedWidgetOnly,
    initialSearchId: searchId,
  } = useSearchContext();
  const { mode } = useAtomValue(searchResultStreamAtom);

  useEffect(() => {
    if (
      !notEmpty(mode) ||
      !notEmpty(searchId) ||
      !notEmpty(searchText) ||
      searchId === sentSearchId ||
      searchText === sentSearchText
    )
      return;

    sendGA4Tracking({
      action: "sys",
      category: "search",
      customized_parameters: {
        search_id: searchId,
        search_text: searchText,
        widget_name: (() => {
          if (embedMode || embedWidgetOnly) return "Explore key angles";
          switch (mode) {
            case "NAVIGATOR":
              return "Explore key angles";
            case "TIMELINE":
              return "Follow the timeline";
          }
        })(),
      },
      subcategory: "result",
    } as SearchEvent);

    setSentSearchId(searchId);
    setSentSearchText(searchText);
  }, [embedMode, embedWidgetOnly, mode, searchId, searchText, sentSearchId, sentSearchText]);
};
